import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import promocodeBg from '../../assets/images/promocode_bg.svg';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding: 20px;
	background-image: url(${promocodeBg});
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 5px;
`;

const StyledTopContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;

	${Text} {
		font-size: 16px;
		color: #ffffff;
	}
`;

const StyledBottomContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;

	& > ${Text} {
		font-weight: 400;
		font-size: 14px;
		line-height: 16px;

		&.green {
			color: #00ff37;
		}

		&.red {
			color: #ff3737;
		}
	}
`;

const StyledInputContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 40px;
	gap: 10px;
`;

export {
	StyledBottomContainer,
	StyledContainer,
	StyledInputContainer,
	StyledTopContainer,
};
